/* ==========================================================================
   RW Forms — submission (loaded before rwf-core.js).
   Mirrors the Sales Sample Tool: when the section has an ERP endpoint set,
   POST multipart (JSON payload + files) with the Liquid-generated HMAC
   pageId/key; otherwise fill the hidden native Shopify contact form so the
   store's "Customer contact" email carries every answer, then show success
   after Shopify redirects back with contact_posted=true.
   ========================================================================== */
(function () {
  'use strict';
  var RWF = (window.RWF = window.RWF || {});

  function stamp() {
    try {
      return new Date().toLocaleString('en-US', {
        timeZone: 'America/New_York', dateStyle: 'full', timeStyle: 'short'
      }) + ' ET';
    } catch (e) {
      return new Date().toString();
    }
  }

  function bodyText(form, c, meta) {
    var lines = [];
    lines.push((meta.title || form.id).toUpperCase() + (meta.subject ? ' — ' + meta.subject : ''));
    lines.push('Submitted: ' + meta.submittedAt);
    if (meta.routeEmail) lines.push('Route to: ' + meta.routeEmail);
    c.sections.forEach(function (s) {
      if (!s.rows.length) return;
      lines.push('');
      lines.push('== ' + String(s.title).toUpperCase() + ' ==');
      s.rows.forEach(function (r) { lines.push(r.label + ': ' + r.value); });
    });
    if (c.extra.length) {
      lines.push('');
      lines.push('== ADDITIONAL ==');
      c.extra.forEach(function (r) { lines.push(r.label + ': ' + r.value); });
    }
    var names = fileNames(form);
    if (names.length && !meta.endpoint) {
      lines.push('');
      lines.push('Files selected (not attached — customer asked to email them): ' + names.join(', '));
    }
    return lines.join('\n');
  }

  function fileNames(form) {
    var out = [];
    Object.keys(form.files).forEach(function (k) {
      var f = form.fields[k];
      if (!f || !form.active(f)) return;
      form.files[k].forEach(function (file) { out.push(file.name); });
    });
    return out;
  }

  function meta(form) {
    var cfg = form.cfg;
    var root = form.root;
    return {
      form: form.id,
      title: root.getAttribute('data-form-title') || cfg.title || form.id,
      subject: cfg.subject ? cfg.subject(form.v, form) : '',
      routeEmail: (cfg.routeEmail && cfg.routeEmail(form.v, form)) || root.getAttribute('data-route-email') || '',
      ccEmail: root.getAttribute('data-cc-email') || '',
      endpoint: root.getAttribute('data-endpoint') || '',
      submittedAt: stamp()
    };
  }

  function busy(form, on) {
    form.$$('[data-rwf-next]').forEach(function (b) {
      b.disabled = on;
      b.textContent = on ? 'Sending…' : (form.root.getAttribute('data-submit-label') || 'Submit');
    });
  }

  function fail(form, msg) {
    busy(form, false);
    var box = form.$('[data-rwf-errors]');
    if (!box) return;
    box.hidden = false;
    box.querySelector('.rwf-errors__list').innerHTML = '<span>' + RWF.esc(msg) + '</span>';
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function successVars(form, m) {
    return Object.assign({ routeEmail: m.routeEmail, hasFiles: fileNames(form).length && !m.endpoint ? 'yes' : '' },
      form.cfg.successVars ? form.cfg.successVars(form.v, form) : {});
  }

  function viaEndpoint(form, c, m) {
    var root = form.root;
    var url = m.endpoint;
    var pageId = root.getAttribute('data-page-id');
    var key = root.getAttribute('data-hash-key');
    if (pageId && key) url += (url.indexOf('?') > -1 ? '&' : '?') + 'pageId=' + encodeURIComponent(pageId) + '&key=' + encodeURIComponent(key);
    var fd = new FormData();
    var payload = Object.assign({}, m, { sections: c.sections, data: c.data, extra: c.extra, body: bodyText(form, c, m) });
    if (form.cfg.payload) payload = form.cfg.payload(payload, form) || payload;
    delete payload.endpoint;
    fd.append('payload', JSON.stringify(payload));
    Object.keys(form.files).forEach(function (k) {
      var f = form.fields[k];
      if (!f || !form.active(f)) return;
      form.files[k].forEach(function (file) { fd.append('files', file, file.name); fd.append('fileFields', k); });
    });
    // A form may generate its own attachment that isn't a real file input
    // (e.g. rwf-knife's engraving preview, rendered to an image at submit
    // time). extraFiles resolves to a list of {name, file} pairs to append
    // alongside any real uploads above.
    Promise.resolve(form.cfg.extraFiles ? form.cfg.extraFiles(form) : null)
      .catch(function () { return null; })
      .then(function (extra) {
        (extra || []).forEach(function (item) {
          if (item && item.file) { fd.append('files', item.file, item.name || item.file.name); fd.append('fileFields', item.name || 'extra'); }
        });
        return fetch(url, { method: 'POST', body: fd });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        form.showSuccess(null, successVars(form, m));
      })
      .catch(function () { fail(form, 'We could not send your form right now. Please try again in a moment.'); });
  }

  function viaContactForm(form, c, m) {
    var cf = form.root.querySelector('.rwf-hidden-form form, form.rwf-hidden-form');
    if (!cf) { fail(form, 'Submission form is unavailable. Please refresh and try again.'); return; }
    var v = form.v;
    var put = function (name, val) {
      var el = cf.querySelector('[name="' + name + '"]');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        cf.appendChild(el);
      }
      el.value = val == null ? '' : val;
    };
    put('contact[email]', v.email || '');
    put('contact[name]', [v.first, v.last].filter(Boolean).join(' ') || v.name || '');
    put('contact[phone]', v.phone || '');
    put('contact[Form]', m.title);
    put('contact[Subject]', m.subject);
    put('contact[Route To]', m.routeEmail);
    put('contact[body]', bodyText(form, c, m));
    try {
      sessionStorage.setItem('rwf:done:' + form.id, JSON.stringify({ v: v, vars: successVars(form, m) }));
      localStorage.removeItem(form.key());
    } catch (e) { /* storage unavailable: success copy falls back */ }
    cf.submit();
  }

  RWF.submit = function (form) {
    // A form with its own working backend contract (e.g. rwf-recommend-product
    // replicating the live Asana-task endpoint) provides cfg.submit and skips
    // the generic ERP/contact-form paths entirely.
    if (form.cfg.submit) { form.cfg.submit(form, busy, fail); return; }
    var c = form.collect();
    var m = meta(form);
    busy(form, true);
    if (m.endpoint) viaEndpoint(form, c, m);
    else viaContactForm(form, c, m);
  };

  /* Called by the engine on load: returns saved success state after the
     contact-form redirect, or null. */
  RWF.pendingSuccess = function (form) {
    var posted = form.root.querySelector('[data-rwf-posted]') || /contact_posted=true/.test(window.location.search);
    if (!posted) return null;
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem('rwf:done:' + form.id) || 'null'); } catch (e) { saved = null; }
    if (!saved && !form.root.querySelector('[data-rwf-posted]')) return null;
    return saved || { v: {}, vars: {} };
  };
})();
